import { render, staticRenderFns } from "./ManagerWrapper.vue?vue&type=template&id=ee9845e4"
import script from "./ManagerWrapper.vue?vue&type=script&lang=js"
export * from "./ManagerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports